{
"api": {
"baseUrl": "https://devtest-xreg-api.segestest.dk"
}
}
